import { Ref } from '@wix/materializer'

type MaybeRef<T> = { [key in keyof T]: T[key] | Ref<T[key]> }

export type Planner<DataItem, PlanResult, ViewerItem = DataItem> = {
	plan: (dataItem: DataItem) => MaybeRef<PlanResult>
	toViewItem: (resolvedItem: PlanResult) => ViewerItem
}

export const createPlanner = <DataItem, PlanResult, ViewerItem = DataItem>(
	plan: (dataItem: DataItem) => MaybeRef<PlanResult>,
	toViewItem: (resolvedItem: PlanResult) => ViewerItem = (x) => (x as any) as ViewerItem
): Planner<DataItem, PlanResult, ViewerItem> => ({
	plan,
	toViewItem,
})
